// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import accordion from "@werner/XDL/PreStyle/accordion";
import breadcrumbs from "@werner/XDL/PreStyle/breadcrumbs";
import breakpoints from "@werner/XDL/PreStyle/breakpoints";
import button from "@werner/XDL/PreStyle/button";
import checkbox from "@werner/XDL/PreStyle/checkbox";
import clickable from "@werner/XDL/PreStyle/clickable";
import colors from "@werner/XDL/PreStyle/colors";
import dataTable from "@werner/XDL/PreStyle/dataTable";
import datePicker from "@werner/XDL/PreStyle/datePicker";
import drawer from "@werner/XDL/PreStyle/drawer";
import dynamicDropdown from "@werner/XDL/PreStyle/dynamicDropdown";
import fileUpload from "@werner/XDL/PreStyle/fileUpload";
import focus from "@werner/XDL/PreStyle/focus";
import formField from "@werner/XDL/PreStyle/formField";
import globalStyle from "@werner/XDL/PreStyle/globalStyle";
import header from "@werner/XDL/PreStyle/header";
import link from "@werner/XDL/PreStyle/link";
import lists from "@werner/XDL/PreStyle/lists";
import loadingSpinner from "@werner/XDL/PreStyle/loadingSpinner";
import menu from "@werner/XDL/PreStyle/menu";
import modal from "@werner/XDL/PreStyle/modal";
import overflowMenu from "@werner/XDL/PreStyle/overflowMenu";
import pagination from "@werner/XDL/PreStyle/pagination";
import panelMenu from "@werner/XDL/PreStyle/panelMenu";
import radio from "@werner/XDL/PreStyle/radio";
import select from "@werner/XDL/PreStyle/select";
import shadows from "@werner/XDL/PreStyle/shadows";
import tab from "@werner/XDL/PreStyle/tab";
import tag from "@werner/XDL/PreStyle/tag";
import textArea from "@werner/XDL/PreStyle/textArea";
import textField from "@werner/XDL/PreStyle/textField";
import toast from "@werner/XDL/PreStyle/toast";
import tooltip from "@werner/XDL/PreStyle/tooltip";
import typography from "@werner/XDL/PreStyle/typography";
import zIndex from "@werner/XDL/PreStyle/zIndex";
import { xBaseTheme } from "@werner/XDL/types";

export default {
    breakpoints,
    colors,
    focus,
    shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    // clickable,
    dataTable,
    datePicker,
    // drawer,
    dynamicDropdown,
    fileUpload,
    header,
    formField,
    // fieldSet,
    // icon,
    // layoutTable,
    // layoutGroup,
    // layoutCell,
    link,
    lists,
    // lazyImage,
    // loadingOverlay,
    loadingSpinner,
    menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    // swatch,
    tab,
    tag,
    // tagsField,
    textField,
    // tokenExFrame,
    textArea,
    toast,
    tooltip,
} as xBaseTheme;
